import 'whatwg-fetch';
import { UserLocationObj } from './UserLocationContext';

interface IPResponse {
    ip: string;
    city: string;
    region: string;
    region_code: string;
    country: string;
    country_name: string;
    continent_code: string;
    in_eu: boolean;
    postal: string;
    latitude: number;
    longitude: number;
    timezone: string;
    utc_offset: string;
    country_calling_code: string;
    currency: string;
    languages: string;
    asn: string;
    org: string;
}

export const getUserLocation = (): Promise<UserLocationObj | null> =>
    fetch('https://ipapi.co/json/')
        .then<IPResponse>((response) => {
            if (response.status !== 200) {
                throw new Error('Not able to fetch user location');
            }

            return response.json();
        })
        .then((ipResponse) => {
            return {
                isFallback: false,
                country: {
                    iso_code: ipResponse.country,
                },
            };
        })
        .catch((e) => {
            return null;
        });
